import { INameIdObj } from '@fi-shared/fi-shared-interfaces';

export enum FiChecklistTimeIntervalDataType {
    Day,
    FirstWeekDay,
    LastWeekDay,
    LastDay,
}
/*
export const ChecklistTimeIntervalDataTypes: INameIdObj[] = [{
    Id: FiChecklistTimeIntervalDataType.Day,
    Name: 'date.day_of_month'
}, {
    Id: FiChecklistTimeIntervalDataType.FirstWeekDay,
    Name: 'date.first_week_day_of_month'
}, {
    Id: FiChecklistTimeIntervalDataType.LastWeekDay,
    Name: 'date.last_week_day_of_month'
}, {
    Id: FiChecklistTimeIntervalDataType.LastDay,
    Name: 'date.last_day_of_month'
}];
*/
export const FiChecklistStartTimeIntervalDataTypes: INameIdObj[] = [
    {
        Id: FiChecklistTimeIntervalDataType.Day,
        Name: 'date.day_of_month',
    },
];

export const FiChecklistEndTimeIntervalDataTypes: INameIdObj[] = [
    {
        Id: FiChecklistTimeIntervalDataType.Day,
        Name: 'date.day_of_month',
    },
    {
        Id: FiChecklistTimeIntervalDataType.LastDay,
        Name: 'date.last_day_of_month',
    },
];
